
import { BasePathPipe } from './base-path.pipe';
import { ObjToStringPipe } from './obj-to-string.pipe';
import { SecondsToMinutesPipe } from './seconds-to-minutes.pipe';
import { SelectionCheckerPipe } from './selection-checker.pipe';
import { SubstringPipe } from './substring.pipe';

export const PIPES = [SubstringPipe, BasePathPipe, SelectionCheckerPipe, SecondsToMinutesPipe, ObjToStringPipe];

